
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator", "currentSlide"]

  connect() {
    this.currentIndex = 0;
    this.totalSlides = this.slideTargets.length;
    this.hasInteracted = false;

    this.touchOrigin = null;
    this.suppressClickUntil = 0;
    this._clickHandler = (event) => {
      if (Date.now() < this.suppressClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    this.element.addEventListener("click", this._clickHandler, true);
    if (this.totalSlides) this.showSlide(this.currentIndex);

    if (this.totalSlides <= 1) {
      return;
    }

    this._keydownHandler = (e) => {
      if (e.key === 'ArrowLeft') {
        this.prev();
      } else if (e.key === 'ArrowRight') {
        this.next();
      }
    };
    document.addEventListener('keydown', this._keydownHandler);
  }

  disconnect() {
    document.removeEventListener('keydown', this._keydownHandler);
    this.element.removeEventListener('click', this._clickHandler, true);
  }

  showSlide(index) {
    this.lazyLoadSlide(index);

    // Hide all slides
    this.slideTargets.forEach((slide, i) => {
      slide.classList.remove('opacity-100');
      slide.classList.add('opacity-0');
      slide.style.pointerEvents = i === index ? 'auto' : 'none';
      slide.inert = i !== index;
    });
    // Show current slide
    this.slideTargets[index].classList.remove('opacity-0');
    this.slideTargets[index].classList.add('opacity-100');

    // Update indicators
    this.indicatorTargets.forEach((indicator, i) => {
      if (i === index) {
        indicator.classList.remove('bg-opacity-50');
        indicator.classList.add('bg-white');
      } else {
        indicator.classList.add('bg-opacity-50');
        indicator.classList.remove('bg-white');
      }
    });

    // Update counter
    if (this.hasCurrentSlideTarget) {
      this.currentSlideTarget.textContent = index + 1;
    }
    this.currentIndex = index;
    if (this.hasInteracted) this.lazyLoadNearbySlides(index);
  }

  lazyLoadNearbySlides(index) {
    this.lazyLoadSlide((index + 1) % this.totalSlides);
  }

  lazyLoadSlide(index) {
    const slide = this.slideTargets[index];
    if (!slide) return;

    slide.querySelectorAll("[data-slideshow-src]").forEach((media) => {
      media.src = media.dataset.slideshowSrc;
      media.removeAttribute("data-slideshow-src");
    });
    slide.querySelectorAll("[data-slideshow-poster]").forEach((media) => {
      media.poster = media.dataset.slideshowPoster;
      media.removeAttribute("data-slideshow-poster");
    });
  }

  touchStart(event) {
    this.touchOrigin = null;
    if (event.touches.length !== 1 || event.target.closest("button:not([data-slideshow-photo]), a, video, input")) return;
    const touch = event.touches[0];
    this.touchOrigin = { x: touch.clientX, y: touch.clientY };
  }

  touchEnd(event) {
    const origin = this.touchOrigin;
    this.touchOrigin = null;
    if (!origin || event.touches.length || this.totalSlides <= 1) return;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - origin.x;
    const dy = touch.clientY - origin.y;
    if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
    this.suppressClickUntil = Date.now() + 500;
    if (dx < 0) this.next();
    else this.prev();
  }

  touchCancel() {
    this.touchOrigin = null;
  }

  next() {
    this.hasInteracted = true;
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
    this.showSlide(this.currentIndex);
  }

  prev() {
    this.hasInteracted = true;
    this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
    this.showSlide(this.currentIndex);
  }

  goTo(event) {
    this.hasInteracted = true;
    let index = Number(event.currentTarget.dataset.slide);
    this.showSlide(index);
  }
}
